<template>
  <div>
    <!-- 登录弹窗 -->
    <div v-if="open" class="login-box mm target-box" style="display: block">
      <div class="taget-close" @click="open = false"></div>
      <div class="box">
        <!-- <div class="wx-login"><img src="/template/pc/skin/images/icon52.png" alt=""></div> -->
        <div class="l-menu">
          <div class="way" :class="{ on: loginType === 'email' }" @click="loginType = 'email'">
            邮箱登录
          </div>
          <div class="way" :class="{ on: loginType === 'phone' }" @click="loginType = 'phone'">
            手机登录
          </div>
        </div>
        <div class="l-box">
          <!-- 邮箱登录 -->
          <div v-if="loginType === 'email'">
            <input type="text" class="txt" id="tel" placeholder="邮箱" v-model="form.email" />
            <input type="password" class="txt" id="password" placeholder="密码" v-model="form.password" />
          </div>
          <!-- 手机登录 -->
          <div class="tel" v-if="loginType === 'phone'">
            <span>+86</span>
            <input type="text" class="txt" id="phone1" v-model="form.phone" placeholder="手机号" />
          </div>
          <!-- <div class="hbox">
            <div class="verify-wrap" id="verify-wrap"></div>
          </div> -->
          <div v-if="loginType === 'phone'" class="yzm">
            <input type="text" id="code1" class="txt" v-model="form.code" placeholder="请输入验证码" />
            <input v-if="loginType === 'phone'" type="button" class="btns" id="btns" :value="buttonText" :disabled="isButtonDisabled" @click="fetchData" />
          </div>

          <a href="javascript:;"><input type="button" @click="submitForm1" class="btn" value="登录" /></a>
          <div class="ckbox">
            <div class="ck on">
              <!-- <img src="https://www.yasubit.com/template/pc/skin/images/icon38.png" alt="" /><img
                src="https://www.yasubit.com/template/pc/skin/images/icon38-1.png"
                alt=""
              />
              下次自动登录 -->
            </div>
            <div class="other">
              <div class="wjmm wjyx" @click="resetPassword">忘记密码</div>
              <div class="zczh" @click="registerOpen = true">注册</div>
            </div>
          </div>
        </div>
        <!-- 微信登录 -->
        <div class="other-login">
          <div class="txt">第三方账号登录</div>
          <div class="abox">
            <a href="/index.php?m=plugins&amp;c=WxLogin&amp;a=login"><img
                :src="weixinIcon" alt="" style="width: 80px; height: 80px;" /><img
                :src="weixinIcon" alt="" @click="login()" style="width: 80px; height: 80px;" /></a>
            <!--  <a href="javascript:;"><img src="/template/pc/skin/images/icon54.png" alt=""><img src="/template/pc/skin/images/icon54-1.png" alt=""></a>

                <a href="javascript:;"><img src="/template/pc/skin/images/icon55.png" alt=""><img src="/template/pc/skin/images/icon55-1.png" alt=""></a> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <div v-if="registerOpen" class="registered-box email-tc target-box" style="display: block;">
      <div class="taget-close" @click="registerOpen = false, open = false"></div>
      <div class="box">
        <div class="t-menu">
          <!--<div class="title t-tel">手机注册</div>-->
          <div class="title t-email on">邮箱注册</div>
        </div>
        <div class="email">
          <input type="text" class="txt temail" placeholder="邮箱" v-model="form.email" />
          <input type="password" class="txt password" placeholder="8-20位密码，字母/数字/符号至少两种" v-model="form.password" />
          <div class="tips">8-20位密码，字母/数字/符号至少两种</div>
        </div>
        <div class="yzm">
          <input type="text" class="txt code" id="code" placeholder="请输入验证码" v-model="form.code" />

          <input type="button" class="btns" id="btn3" :value="registerButtonText" :disabled="isRegisterButtonDisabled" @click="fetchData" />

          <!-- <div class="tips">验证码错误或者超时失效</div> -->
        </div>

        <div class="ckbox">
          <div class="ck on">
            <img src="https://www.yasubit.com/template/pc/skin/images/icon38.png" alt="" /><img
              src="https://www.yasubit.com/template/pc/skin/images/icon38-1.png" alt="" />
            我已阅读并接受<a href="/#/privacy">隐私条款</a>
          </div>
        </div>

        <input type="button" class="btn3" @click="register" value="注册" />

        <div class="other">
          已有账号，<span class="gologin" @click="registerOpen = false">马上登录</span><a href="/"><span
              class="back">返回主页</span></a>
        </div>

        <div class="other-login">
          <div class="txt">使用社交账号注册</div>

          <div class="abox">
            <a href="javascript:;"><img src="https://www.yasubit.com/template/pc/skin/images/icon53.png" alt="" /><img
                src="https://www.yasubit.com/template/pc/skin/images/icon53-1.png" alt="" @click="login()" /></a>

            <!--  <a href="javascript:;"><img src="/template/pc/skin/images/icon54.png" alt=""><img src="/template/pc/skin/images/icon54-1.png" alt=""></a>

                <a href="javascript:;"><img src="/template/pc/skin/images/icon55.png" alt=""><img src="/template/pc/skin/images/icon55-1.png" alt=""></a> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 找回密码 -->
    <div v-if="resetPasswordDialog" class="forgot-password forgot-yx target-box" style="display: block;">
      <div class="taget-close" @click="resetPasswordDialog = false, open = false"></div>
      <div class="box">
        <div class="title">找回密码</div>
        <div class="lbox">
          <input type="text" class="txt" id="yxtext" placeholder="邮箱" v-model="form.email">
        </div>
        <div class="yzm">
          <input type="text" id="yxyzm" class="txt" placeholder="请输入验证码" v-model="form.code">
          <input type="button" class="btn" id="btn-yx" :value="resetPasswordButtonText" :disabled="isResetPasswordButtonDisabled" @click="sendMailCode">
        </div>
        <div class="lbox2">
          <input type="text" class="txt" id="yxmm1" placeholder="设置新密码" v-model="form.newPassword">
          <input type="text" class="txt" id="yxmm2" placeholder="再次输入新密码" v-model="form.newPasswordConfirm">
        </div>
        <p class="f_tishi" style="color:red;line-height:1.4;display:none;">8-20位密码，字母/数字/符号至少两种</p>
        <input type="button" value="重置密码" class="cz cz-yx" @click="resetPwd">
        <div class="other"><span class="gologin-yx" @click="resetPasswordDialog=false, open=true">返回登录</span><span class="back" @click="returnHome">返回主页</span> </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import axios from "axios";
import weixinIcon from "@/assets/icon/weixin.png";
export default {
  props: {
    userTest: {},
  },
  data() {
    return {
      weixinIcon: weixinIcon,
      isLogin: false,
      isButtonDisabled: false,
      countdown: 60,
      buttonText: "发送验证码",
      // 注册页面的倒计时
      isRegisterButtonDisabled: false,
      registerCountdown: 60,
      registerButtonText: "发送验证码",
      // 找回密码页面的倒计时
      isResetPasswordButtonDisabled: false,
      resetPasswordCountdown: 60,
      resetPasswordButtonText: "发送验证码",
      //status=1时为手机号验证码发送请求，status=2时为邮箱验证码请求，status为3时...
      status: 0,
      open: false, // 登录页面
      registerOpen: false, //注册页面
      resetPasswordDialog: false, //重置密码页面
      loginType: "email", // 默认选中邮箱登录
      form: {
        codeType: 0,
        code: undefined,
        // email: "2575167372@qq.com",
        // password: "hxf123456789",
      }, // 登录表单
      rules: {
        email: [{ required: true, message: "邮箱不能为空", trigger: "blur" }],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      token: "", //后端返回的token
      user: undefined,
    };
  },
  methods: {
    reloadPage() {
      // 使用 $router.replace 刷新当前页面
      // this.$router.push({ path: 'home1' });
    },
    // 表单重置
    resetForm() {
      this.form = {
        codeType: 0,
        code: undefined,
      }
    },
    startCountdown() {
      this.isButtonDisabled = true;
      this.buttonText = `${this.countdown} 秒后可重新获取`;

      // 启动计时器，每秒更新一次倒计时
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          this.buttonText = `${this.countdown} 秒后可重新获取`;
        } else {
          // 计时器结束时重置按钮状态
          this.resetButton();
        }
      }, 1000);
    },
    resetButton() {
      clearInterval(this.timer);
      this.isButtonDisabled = false;
      this.countdown = 60;
      this.buttonText = "发送验证码";
    },
    // 注册页面倒计时
    startRegisterCountdown() {
      this.isRegisterButtonDisabled = true;
      this.registerButtonText = `${this.registerCountdown} 秒后可重新获取`;

      this.registerTimer = setInterval(() => {
        if (this.registerCountdown > 0) {
          this.registerCountdown--;
          this.registerButtonText = `${this.registerCountdown} 秒后可重新获取`;
        } else {
          this.resetRegisterButton();
        }
      }, 1000);
    },
    resetRegisterButton() {
      clearInterval(this.registerTimer);
      this.isRegisterButtonDisabled = false;
      this.registerCountdown = 60;
      this.registerButtonText = "发送验证码";
    },
    // 找回密码页面倒计时
    startResetPasswordCountdown() {
      this.isResetPasswordButtonDisabled = true;
      this.resetPasswordButtonText = `${this.resetPasswordCountdown} 秒后可重新获取`;

      this.resetPasswordTimer = setInterval(() => {
        if (this.resetPasswordCountdown > 0) {
          this.resetPasswordCountdown--;
          this.resetPasswordButtonText = `${this.resetPasswordCountdown} 秒后可重新获取`;
        } else {
          this.resetResetPasswordButton();
        }
      }, 1000);
    },
    resetResetPasswordButton() {
      clearInterval(this.resetPasswordTimer);
      this.isResetPasswordButtonDisabled = false;
      this.resetPasswordCountdown = 60;
      this.resetPasswordButtonText = "发送验证码";
    },
    fetchData() {
      //手机号验证码
      if (this.registerOpen === false) {
        // 在按钮点击后启动计时器
        this.startCountdown();
        if (this.form.phone == null) {
          this.$message.error("手机号不能为空");
          // 如果验证失败，重置倒计时
          this.resetButton();
          return;
        }
        // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
        const headers = {
          Authorization: "",
          // 可以添加其他自定义请求头
          // // 'Custom-Header': 'YourCustomHeaderValue',
        };

        // 定义请求体，替换 'yourPayloadData' 为实际的请求体数据

        const postData = {
          // 你的请求体数据在这里
          phone: this.form.phone,
          codeType: 2,
        };

        // 发送 POST 请求并在请求中添加自定义请求头
        this.$http
          .post("yasubit/users/sendMessageCode", postData, { headers })
          .then((response) => {
            // 请求成功时更新数据
            console.log(1111111111);
            if (response.data.code === 200) {
              this.$message.success("验证码已发送");
            } else {
              this.$message.error(response.data.msg);
              // 如果发送失败，重置倒计时
              this.resetButton();
            }
          })
          .catch((error) => {
            // 请求失败时处理错误
            console.error("Error fetching data:", error);
            // 如果请求失败，重置倒计时
            this.resetButton();
          });
      } else {
        // 注册页面，启动注册倒计时
        this.startRegisterCountdown();
        if (this.form.email == null) {
          this.$message.error("邮箱不能为空");
          // 如果验证失败，重置倒计时
          this.resetRegisterButton();
          return;
        }
        // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
        const headers = {
          Authorization: "",
          // 可以添加其他自定义请求头
          // // 'Custom-Header': 'YourCustomHeaderValue',
        };

        // 定义请求体，替换 'yourPayloadData' 为实际的请求体数据

        const postData = {
          // 你的请求体数据在这里
          email: this.form.email,
          sendMailType: 2,
        };

        // 发送 POST 请求并在请求中添加自定义请求头
        this.$http
          .post("yasubit/users/sendMailCode", postData, { headers })
          .then((response) => {
            // 请求成功时更新数据
            console.log(1111111111);
            if (response.data.code === 200) {
              this.$message.success("验证码已发送");
            } else {
              this.$message.error(response.data.msg);
              // 如果发送失败，重置倒计时
              this.resetRegisterButton();
            }
          })
          .catch((error) => {
            // 请求失败时处理错误
            console.error("Error fetching data:", error);
          });
      }
    },

    replay() {
      this.registerOpen = false;
      this.open = false;
    },
    login() {
      this.$router.push({ path: "Login" });
    },
    showLoginDialog() {
      this.open = true;
    },
    showRegisterDialog() {
      this.registerOpen = true;
    },
    switchToPhoneLogin() {
      this.loginType = "phone";
    },
    switchToEmailLogin() {
      this.loginType = "email";
    },

    submitForm1() {
      if (this.loginType === "phone") {
        //手机号验证码登录
        // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
        const headers = {
          Authorization:
            "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjBhNDUxNTgyLTZiMjYtNDUzNy1hN2NjLTQ5OTIzMjg0NWEzMSJ9.HTkalwe0xlA8sPIDk143-c4vaxBtbnHPlMPDLdeEi9xm_9fYrgdBuZnArlXl9d1HJia9VWDcLU8Fl_uuKyvEhQ",
          // 可以添加其他自定义请求头
          // // 'Custom-Header': 'YourCustomHeaderValue',
        };
        // 定义请求体，替换 'yourPayloadData' 为实际的请求体数据
        const postData = {
          // 你的请求体数据在这里
          phone: this.form.phone,
          code: this.form.code,
          codeType: 2,
        };
        // 发送 POST 请求并在请求中添加自定义请求头
        this.$http
          .post("yasubit/users/loginByMessageCode", postData, { headers })
          .then((response) => {
            // 请求成功时更新数据
            console.log(response.data.code);

            if (
              response.data.msg === "验证码错误" ||
              response.data.msg === "验证码失效"
            ) {
              this.$message.error("手机号或验证码错误");
              return;
            } else {
              window.location.href = "/";
              this.$message.success("登录成功");
            }

            this.open = false;
            this.form.email = null;
            this.form.code = null;
            this.form.password = null;

            this.isLogin = true;
            // 使用localStorage保存登录数据
            localStorage.setItem("loginStatus", JSON.stringify(this.isLogin));
            localStorage.setItem("loginToken", response.data.data);
            // this.data = response.data;
          })
          .catch((error) => {
            // 请求失败时处理错误
            console.error("Error fetching data:", error);
          });
      } else {
        //邮箱密码登录
        // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
        const headers = {
          Authorization: "",
          // 可以添加其他自定义请求头
          // // 'Custom-Header': 'YourCustomHeaderValue',
        };
        // 定义请求体，替换 'yourPayloadData' 为实际的请求体数据
        const postData = {
          // 你的请求体数据在这里
          email: this.form.email,
          password: this.form.password,
          codeType: 2,
        };
        // 发送 POST 请求并在请求中添加自定义请求头
        this.$http
          .post("yasubit/users/loginByMail", postData, { headers })
          .then((response) => {
            // 请求成功时更新数据
            console.log(1111111111);
            console.log(response.data.data);
            // this.data = response.data;
            if (response.data.code === 500) {
              this.$message.warning("密码错误或该用户名不存在！");
              return;
            }
            window.location.href = "/";
            this.$message.success("登录成功");
            // this.reloadPage()

            this.open = false;
            this.form.email = null;
            this.form.code = null;
            this.form.password = null;
            this.isLogin = true;
            // 使用localStorage保存登录数据
            localStorage.setItem("loginStatus", JSON.stringify(this.isLogin));
            localStorage.setItem("loginToken", response.data.data);
          })
          .catch((error) => {
            // 请求失败时处理错误
            console.error("Error fetching data:", error);
          });
      }
    },

    async submitForm() {
      try {
        const response = await this.getToken(this.form);
        this.token = response.data;
        axios.defaults.headers.common["Authorization"] = this.token;
        const loginResponse = await this.loginByEmail();
        this.user = loginResponse.data;
        this.$emit("user-updated", this.user);
        this.$message.success(loginResponse.data.msg);
        this.open = false;
      } catch (error) {
        console.error(error);
        this.$message.error(error);
      }
    },
    sendCode() {
      console.log(this.form);
      // this.getCode(this.form)
      //   .then((response) => {
      //     this.$message.success(response.msg);
      //   })
      //   .catch((error) => {
      //     this.$message.error(error);
      //   });
    },
    resetPassword() {
      this.open = false;
      this.resetPasswordDialog = true;
      this.resetForm();
    },
    resetPwd() {
      this.$http
        .post("yasubit/users/resetPassword", this.form)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(response.data.msg);
          } else {
            this.$message.error(response.data.msg);
          }
          this.resetForm();
          this.resetPasswordDialog = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    sendMailCode() {
      // 启动找回密码倒计时
      this.startResetPasswordCountdown();
      
      if (this.form.email == null) {
        this.$message.error("邮箱不能为空");
        // 如果验证失败，重置倒计时
        this.resetResetPasswordButton();
        return;
      }
      
      const postData = {
        "email": this.form.email,
        "sendMailType": 4
      }
      this.$http
        .post("yasubit/users/sendMailCode", postData)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(response.data.msg);
          } else {
            this.$message.error(response.data.msg);
            // 如果发送失败，重置倒计时
            this.resetResetPasswordButton();
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          // 如果请求失败，重置倒计时
          this.resetResetPasswordButton();
        });
    },
    returnHome() {
      window.location.href = "/";
    },
    register() {
      console.log(this.form.email);
      console.log(this.form.password);

      //手机号验证码登录
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {
        Authorization: "",
        // 可以添加其他自定义请求头
        // // 'Custom-Header': 'YourCustomHeaderValue',
      };
      // 定义请求体，替换 'yourPayloadData' 为实际的请求体数据
      const postData = {
        // 你的请求体数据在这里
        email: this.form.email,
        code: this.form.code,
        password: this.form.password,
        // codeType:2,
      };
      // 发送 POST 请求并在请求中添加自定义请求头
      this.$http
        .post("yasubit/users/registerByMail", postData, { headers })
        .then((response) => {
          // 请求成功时更新数据
          // console.log(1111111111);
          // if (
          //   response.data.msg === "验证码错误" ||
          //   response.data.msg === "验证码失效！"
          // ) {
          //   this.$message.error("邮箱密码或验证码错误");
          // } else {
          //   this.$message.success("注册成功");
          //   this.registerOpen = false;
          //   this.open = false;
          // }
          if (response.data.code === 200) {
            this.$message.success("注册成功");
            this.registerOpen = false;
            this.open = false;
          } else {
            this.$message.error(response.data.msg);
          }

          // this.data = response.data;
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });

      // this.registerByMail(this.form)
      //   .then((response) => {
      //     this.$message.success(response.msg);
      //   })
      //   .catch((error) => {
      //     this.$message.error(error);
      //   });
    },
    registerByMail(data) {
      return axios
        .post("https://smartforest.cn:8080/yasubit/users/registerByMail", data)
        .then((response) => response.data);
    },
    getToken(data) {
      return axios
        .post("https://smartforest.cn:8080/yasubit/users/loginByMail", data)
        .then((response) => response.data);
    },
    loginByEmail() {
      return axios.get("https://smartforest.cn:8080/yasubit/users/info");
    },
    getCode(data) {
      this.form.sendMailType = "2";
      return axios
        .post("https://smartforest.cn:8080/yasubit/users/sendMailCode", data)
        .then((response) => response.data);
    },
  },
  beforeDestroy() {
    // 在组件销毁前清除所有计时器，防止内存泄漏
    clearInterval(this.timer);
    clearInterval(this.registerTimer);
    clearInterval(this.resetPasswordTimer);
  },
};
</script>
<style scoped>
.login-menu {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  /* margin-top: -10px; */
}

.el-menu--horizontal .el-menu-item {
  font-size: 18px;
  margin: 0 20px;
}

.el-button {
  margin-left: 80px;
}

.el-input {
  width: 95%;
}

.code {
  margin-left: 5px;
}

.text-center {
  text-align: center;
  margin-top: 40px;
}

.weixin {
  margin-bottom: 20px;
}
</style>

